import { render, staticRenderFns } from "./SelectPhoneType.vue?vue&type=template&id=9e2b1334&"
import script from "./SelectPhoneType.vue?vue&type=script&lang=js&"
export * from "./SelectPhoneType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports